// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ********************* MEMBER LOAN LIST DETAILS START ******************** */
export const fetchArrearLoanList = (listData: any) => {
	const data = {
		FetchArrearMemberListDataToken: listData,
	};
	const url = `${API_URL}getDemandForArrearCollection`;
	return makeApiCall(url, data);
};
/** ********************* MEMBER LOAN LIST DETAILS END ******************** */

/** ***************** UPDATE ARREAR COLLECTION APPROVE START *********************** */
export const arrearCollectionApproveAPI = (listData: any) => {
	const data = {
		UpdateApproveArrearMemberToken: listData,
	};
	const url = `${API_URL}approveArrearCollections`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE ARREAR COLLECTION APPROVE END *********************** */

/** ***************** UPDATE COMMON LOAN PAID DETAILS START *********************** */
export const updateCommonLoanPaidDetailsAPI = (listData: any) => {
	const data = {
		UpdateCommonLoanPaidDetailsToken: listData,
	};
	const url = `${API_URL}updateCommonLoanPaidDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE COMMON LOAN PAID DETAILS END *********************** */
